export const CALLBACK_PATH = '/auth/callback';
export const callback_url = () => `${window.location.origin}${CALLBACK_PATH}`;

//	-------------------------------------------------
//
//	Redirects the browser to the IAM Login URL.
//
//	-------------------------------------------------

export async function redirectToLoginURL(currentPath: string) {
  try {
    sessionStorage.setItem('postLoginRedirect', currentPath || '/home');
    const loginURI = `https://authn.srcnet.skao.int/api/v1/login/code?redirect_uri=${encodeURIComponent(callback_url())}`;
    // redirect the browser to the login uri.
    window.location.href = loginURI;
  } catch (e) {
    console.log('Error redirecting browser to IAM login URL.');
  }
} // redirectToLoginURL
